import React, { ChangeEvent, Component } from "react";
import Strings from "@my-dld/assets/strings";
import FormSection from "@my-dld/components/Form/FormSection";
import { WebFormFieldProps } from "@eres/forms-web";
import StateHolder from "@eres/forms/StateHolder";
import { defaultErrorManager } from "@eres/forms/errormanager";
import { ErrorContainer } from "@eres/forms";
import CurrencyInputField from "@eres/forms-web/CurrencyInputField";
import { NonZeroValidator } from "@eres/forms/validator/NonZeroValidator";
import { populatePrvtSellLookup } from "../../../apis/privatesell/services";
import { PrvSellLookUp, PvtSellLookUp, Terms } from "../../../apis/privatesell/enitites";
import PickerInput from "@my-dld/components/Form/PickerInput";
import { IPrivateSellForm, IPrivateSellFormProps, IPrivateSellFormState } from "./Base";
import { checkNonEmpty } from "@my-dld/components/Form/FormField";
import { LocaleUtil } from "@eres/core";


interface Props extends IPrivateSellFormProps {
	askingPrice?: string;
	transactionDuration?: PvtSellLookUp;
	listOption?: Terms[];
}

interface State extends IPrivateSellFormState {
	askingPrice?: string;
	transactionDuration?: PvtSellLookUp;
	errorContainer: ErrorContainer;
	TransactionDurations: PvtSellLookUp[];
	selectedListingOptions: Terms[];

}

export default class BookingDetails extends Component<Props, State> implements IPrivateSellForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			isValid: false,
			errorContainer: {},
			askingPrice: props.askingPrice,
			transactionDuration: props.transactionDuration,
			TransactionDurations: [],
			selectedListingOptions: [],
		};
		this.onChange = this.onChange.bind( this );
	}

	componentDidMount(): void {
		populatePrvtSellLookup( PrvSellLookUp.TRANSACTION_DURATIONS, this );
	}

	isValid = ( _isUserAction?: boolean ) => {
		const { askingPrice, transactionDuration } = this.state;
		const state = this.state;
		let isValid = true;
		let errorViews: ErrorContainer = {};
		isValid = checkNonEmpty( state, "askingPrice", errorViews ) && isValid;
		isValid = checkNonEmpty( state, "transactionDuration", errorViews ) && isValid;
		this.setState( { errorContainer: errorViews } );
		return isValid;
	};
	//
	// componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
	//     const oldData = this.getData(prevState);
	//     const newData = this.getData(this.state);
	//     handleDataUpdate(oldData, newData, prevState, this);
	// }

	getData = ( state: State = this.state ) => {
		return {
			askingPrice: state?.askingPrice,
			transactionDuration: state?.transactionDuration,
			selectedListingOptions: state?.selectedListingOptions,
		};
	};

	render() {
		const { readonly, listOption } = this.props;
		const { errorContainer, TransactionDurations, selectedListingOptions } = this.state;
		const filedProps: Partial<WebFormFieldProps<any, any>> = {
			holder: StateHolder.buildStateHolder( this ),
			errorManager: defaultErrorManager,
		};
		const kvProp = { inputClassName: "form-control", holder: this, containerClassName: "col-md-6 form-group" };
		return (
			<div className="tender-registration-form">
				<FormSection title={ Strings.payment_information }>
					<div className={ "row" }>
						<div className={ "col-4" }>
							<CurrencyInputField
								{ ...filedProps }
								containerClassName={ "form-group" }
								required={ true }
								id={ "askingPrice" }
								label={ Strings.asking_price }
								error={ errorContainer.askingPrice }
								valueValidators={ NonZeroValidator }/>
						</div>
						<div className="col-4">
							<PickerInput
								{ ...kvProp }
								label={ Strings.offer_period }
								id={ "transactionDuration" }
								items={ TransactionDurations }
								containerClassName="form-group field-style select-control"
								required={ true }
								error={ errorContainer.transactionDuration }
								toIdentifier={ ( item: PvtSellLookUp ) => item.identity + "" }
								onValueChange={ ( duration?: PvtSellLookUp ) => {
									this.setState( { transactionDuration: duration } );
								} }
							/>
						</div>
					</div>
					{
						listOption != undefined && listOption.length > 0 &&
						listOption.map( option => {
							let selected = selectedListingOptions.find( x => x.termId === option.termId ) != undefined;
							const inpProps = {
								id: option.termId + "",
								className: "custom-control-input",
								onChange: this.onChange,
								checked: selected,
								type: "checkbox",
							};
							return <div className="d-flex pb-2">
								<div className={ "custom-control custom-checkbox mt-3 mb-3" }>
									<input { ...inpProps }/>
									<label className={ "custom-control-label line-height-normal" } htmlFor={ option.termId + "" }>
										<span>{ LocaleUtil.getLocalValue( option.title ) }</span>
										<span className={ "d-flex font-size12" }>{ LocaleUtil.getLocalValue( option.description ) }</span>
									</label>
								</div>
							</div>;
						} )
					}
				</FormSection>
			</div>
		);
	}

	toggleTerms = ( option: Terms, selected: boolean ) => {
		let selectedOptions = this.state.selectedListingOptions.slice();
		if ( selected ) {
			selectedOptions = [];
			selectedOptions.push( option );
		} else {
			let ix = selectedOptions.findIndex( x => x.termId === option.termId );
			if ( ix > -1 ) {
				selectedOptions.splice( ix, 1 );
			}
		}
		this.setState( {
			selectedListingOptions: selectedOptions,
		} );
	};

	onChange = ( event: ChangeEvent<HTMLInputElement> ) => {
		let value = event.target.checked;
		let id = event.target.id;
		const listOption = this.props.listOption;
		if ( listOption ) {
			const selected = listOption.find( x => x.termId + "" === id );
			if ( selected ) this.toggleTerms( selected, value );
		}
	};
}
